enum AuthenticationType {
	MSAL = 'MSAL',
	THIRD_PARTY = 'THIRD_PARTY',
}

export default AuthenticationType;